import axios from 'axios'
import { set } from 'vue'

// Initial state factory function
const getDefaultState = () => {
  return {
    data: []
  }
}

export default {
  state: getDefaultState(),
  mutations: {
    SET_NUMBER_POOLS(state, data) {
      set(state, 'data', data)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getNumberPools({ commit }) {
      const res = await axios.get('/numberPool/list', {
        params: { page: 1, limit: 50, deleted: false }
      })
      commit('SET_NUMBER_POOLS', res.data.content)
    },
    async addNumberPool({ dispatch }, data) {
      const res = await axios.post('/numberPool', data)
      dispatch('getNumberPools')
      return res.status
    },
    async editNumberPool({ dispatch }, { id, data }) {
      const res = await axios.put(`/numberPool/${id}`, data)
      dispatch('getNumberPools')
      return res.status
    },
    async editNumberPoolSmart({ dispatch }, { id, data }) {
      const res = await axios.put(`/numberPool/${id}/smart-update`, data)
      dispatch('getNumberPools')
      return res.status
    }
  }
}
